import * as types from "./mutation-types";

export default {
  [types.SET_RELATORIOS](state, payload) {
    state.relatorios = payload;
  },
  [types.SET_RELATORIO_OPORTUNIDADES](state, payload) {
    state.relatorio_oportunidades = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
